module.exports = __webpack_public_path__ + "static/media/usersettings.21c7a13a.png";